/* Replace third-party app text strings */
(function () {
  var replacements = [
    { from: 'FREE', to: 'مجاني' }
  ];

  function replaceInNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.nodeValue;
      var changed = false;
      replacements.forEach(function (r) {
        if (text.indexOf(r.from) !== -1) {
          text = text.split(r.from).join(r.to);
          changed = true;
        }
      });
      if (changed) node.nodeValue = text;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(replaceInNode);
    }
  }

  /* Run on initial load */
  function runReplace() {
    replaceInNode(document.body);
  }

  /* Watch for dynamic content from apps */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(replaceInNode);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    runReplace();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

/* Scroll to Leadform when clicking luxa-lp-btn-buy */
(function () {
  function scrollToLeadform() {
    var target = document.querySelector('.leadform-button.lfcod-btn-animation-shakeBottom')
      || document.querySelector('.leadform-button')
      || document.querySelector('.lfcod-btn-animation-shakeBottom');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bindBuyButtons() {
    document.querySelectorAll('.luxa-lp-btn-buy, .lxk-btn-buy').forEach(function (btn) {
      if (btn.dataset.scrollBound) return;
      btn.dataset.scrollBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToLeadform();
      });
    });
  }

  /* Bind on load + watch for buttons added dynamically */
  document.addEventListener('DOMContentLoaded', bindBuyButtons);

  var btnObserver = new MutationObserver(bindBuyButtons);
  document.addEventListener('DOMContentLoaded', function () {
    btnObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

/* Scroll to .btn-text when clicking .luxa-btn-buy */
(function () {
  function scrollToBtnText() {
    var target = document.querySelector('.btn-text');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bindLuxaBuyButtons() {
    document.querySelectorAll('.luxa-btn-buy').forEach(function (btn) {
      if (btn.dataset.luxaScrollBound) return;
      btn.dataset.luxaScrollBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToBtnText();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindLuxaBuyButtons);

  var luxaObserver = new MutationObserver(bindLuxaBuyButtons);
  document.addEventListener('DOMContentLoaded', function () {
    luxaObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

/* Webi Leadform: replace variant text buttons with product images */
(function () {
  var imageMap = null;

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.handle;
    }
    return null;
  }

  function buildMap(product) {
    var map = {};
    product.variants.forEach(function (v) {
      var raw = v.featured_image ? v.featured_image.src : (product.images.length ? product.images[0] : null);
      if (!raw) return;
      var src = (typeof raw === 'string' ? raw : raw.src).split('?')[0] + '?width=160';
      ['option1', 'option2', 'option3'].forEach(function (k) {
        if (v[k] && !map[v[k]]) map[v[k]] = src;
      });
    });
    return map;
  }

  function inject() {
    if (!imageMap) return;
    document.querySelectorAll('.lf-variant-btn').forEach(function (btn) {
      if (btn.dataset.imgDone) return;
      var src = imageMap[btn.dataset.value];
      if (!src) return;
      btn.dataset.imgDone = '1';
      btn.innerHTML = '<img src="' + src + '" alt="' + (btn.dataset.value || '') + '">';
    });
  }

  function init() {
    var handle = getHandle();
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        imageMap = buildMap(product);
        inject();
        new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();
